const MAX_CATEGORY_KEY = 2147483647;

export const isValidCategoryKey = (value: string): boolean => /^\d+$/.test(value) && Number(value) <= MAX_CATEGORY_KEY;
